import React, { useContext } from 'react'
import { FormDiplomsContext } from '../types'
import { InputElement } from '../../../HtmlComponents/InputElement'
import { InputImage } from '../../../HtmlComponents/InputImage'
import { hostName } from '../../../requestMethods'
import { InputRadio } from '../../../HtmlComponents/InputRadio'

const InputsDiploms = () => {
  const {
    title, setTitle,
    image, setImage,
    faculty, setFaculty,
    type, setType,
    period, setPeriod,
    dateOfGraduation, setDateOfGraduation,
    yearsOfSuccessfulStudy, setYearsOfSuccessfulStudy,
    placeOfGraduation, setPlaceOfGraduation
  } = useContext(FormDiplomsContext)

  const diplomsType = ["D'etat", "D'Université"]

  return (
    <>
      <InputElement labelClass='text-main' name='Titre' value={title} setValue={setTitle}/>
      <InputElement labelClass='text-main' name='Faculté' value={faculty} setValue={setFaculty}/>
      <InputElement labelClass='text-main' name="Periode d'etudes" value={period} setValue={setPeriod}/>
      <InputElement labelClass='text-main' name="Nombre d'années d'études réussies" value={yearsOfSuccessfulStudy} setValue={setYearsOfSuccessfulStudy}/>
      <InputElement labelClass='text-main' name="Lieu d'obtention" value={placeOfGraduation} setValue={setPlaceOfGraduation}/>      
      <InputElement type='date' labelClass='text-main' name="Date d'obtention" value={dateOfGraduation} setValue={setDateOfGraduation}/>
      <div>
        <p className='font-bold text-main'>Type</p>
        <InputRadio
          checked={type === "D'etat" && true}
          labelName="D'etat" 
          id="D'etat" 
          value={"D'etat"} 
          setValue={setType}
        />
        <InputRadio
          checked={type === "D'Université" && true}
          labelName="D'Université"
          id="D'Université"
          value={"D'Université"}
          setValue={setType}
        />
        <InputRadio
          checked={(type && !diplomsType.includes(type)) ? true : false}
          labelName='Autres'
          id="Autres"
          value={"Autres"}
          setValue={setType}
        />
        {(type && !diplomsType.includes(type)) && <InputElement name="Preciser" value={type} setValue={setType}/>}
      </div>
      <InputImage accept="image/*" name='Photo du diplôme' setValue={setImage}/>
      {/* image comes from db */}
      {(image && (typeof image === 'string')) && <div className='md:col-span-2 flex justify-center items-center'>
        <img className='rounded-full shadow-lg' style={{ width: "100px", height: "100px" }} src={hostName + "imgs/diploms/" + image} alt="sss" /> 
      </div>}
      {/* image choosen from here */}
      {(image && (typeof image !== 'string')) && <div className='md:col-span-2 flex justify-center items-center'>
        <img className='rounded-full shadow-lg' style={{ width: "100px", height: "100px" }} src={URL.createObjectURL(image)} alt="ssdd" /> 
      </div>}


    </>
  )
}

export default InputsDiploms